(() => {
  const header = document.querySelector('.nopa-header');
  if (!header) return;
  const wrap = document.querySelector('.nopa-header-wrap');
  const threshold = parseInt(header.dataset.threshold || '40', 10);

  let abHeight = 0;
  const measureAb = () => {
    const ab = document.querySelector('.announcement-bar, .announcement-bar-section, [class*="announcement"]');
    const sec = ab ? ab.closest('[id^="shopify-section"]') || ab : null;
    abHeight = sec ? sec.offsetHeight : 0;
  };
  measureAb();
  window.addEventListener('resize', measureAb);

  const onScroll = () => {
    header.classList.toggle('is-solid', window.scrollY > threshold);
    if (document.body.classList.contains('nopa-has-hero') && wrap) {
      wrap.style.top = Math.max(0, abHeight - window.scrollY) + 'px';
    }
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(() => { measureAb(); onScroll(); }, 100);

  const drawer = document.getElementById('NopaMenuDrawer');
  const openBtn = document.querySelector('[data-nopa-menu-open]');
  if (drawer && openBtn) {
    const close = () => { drawer.classList.remove('is-open'); document.body.style.overflow = ''; openBtn.setAttribute('aria-expanded', 'false'); };
    openBtn.addEventListener('click', () => { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; openBtn.setAttribute('aria-expanded', 'true'); });
    drawer.querySelectorAll('[data-nopa-menu-close]').forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  const updateBadge = () => {
    const badge = document.querySelector('[data-nopa-wishlist-badge]');
    if (!badge) return;
    let n = 0;
    try { n = (JSON.parse(localStorage.getItem('nopa:wishlist')) || []).length; } catch (e) {}
    badge.textContent = n;
    badge.classList.toggle('is-visible', n > 0);
  };
  updateBadge();
  document.addEventListener('nopa:wishlist:change', updateBadge);

  const langWrap = document.querySelector('[data-nopa-lang]');
  if (langWrap) {
    const toggle = langWrap.querySelector('[data-nopa-lang-toggle]');
    const panel = langWrap.querySelector('[data-nopa-lang-panel]');
    const closeLang = () => {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    };
    const openLang = () => {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    };
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      panel.hidden ? openLang() : closeLang();
    });
    document.addEventListener('click', (e) => {
      if (!langWrap.contains(e.target)) closeLang();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeLang();
    });
  }
})();
